import { TFunction } from 'i18next';
import truncate  from 'lodash-es/truncate';

import i18n from '../i18n';

export const pluralize = (count: number, noun: string, suffix = 's') => {
  const lang = i18n.language;
  if (lang === 'en') {
    return `${noun}${count !== 1 ? suffix : ''}`;
  }
  return noun;
};

export const truncateString = (value: string, length?: number) => {
  const maxLength = length || 20;

  if (value && value.length >= maxLength) {
    return truncate(value, { length: maxLength });
  }

  return value;
};

export const Regexes = {
  EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NAME_REGEX: /^(?![-._\s])[a-zA-Z0-9][-._a-zA-Z0-9\s]{1,18}(?<![-._\s])$/,
  URL_REGEX:
    /^((([a-zA-Z0-9-]{1,256}\.[a-zA-Z0-9-]{2,6})|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?)(\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/,
  DOMAIN_REGEX:
    /^\s*(?!-)(?!.*-$)(?!.*--)[A-Za-z0-9-]{1,63}(\.[A-Za-z0-9-]{1,63})*(\.[A-Za-z]{2,})\s*$/,
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const getFAQItems = (t: TFunction) => {
  return Array.from({ length: 6 }).map((_, index) => ({
    key: String(index + 1),
    label: t(`pricing.faq.faq${index + 1}`),
    children: t(`pricing.faq.faq${index + 1}-answer`),
    headerClass: 'atira-collapse-header',
  }));
};
